import { OkrKeyResult } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setOkrKeyResultList = (keyResultList: types.OkrKeyResultList) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_LIST),
    keyResultList,
})
export const setOkrKeyResultIds = (keyResultIds: types.OkrKeyResultIds) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_IDS),
    keyResultIds,
})
export const setOkrKeyResultEdit = (keyResult: OkrKeyResult) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_EDIT),
    keyResult,
})


// to select parent key result
export const setOkrKeyResultListEdit = (keyResultList: types.OkrKeyResultList) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_LIST_EDIT),
    keyResultList,
})
export const setOkrKeyResultIdsEdit = (keyResultIds: number[]) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_IDS_EDIT),
    keyResultIds,
})


// popup menu
export const setOkrKeyResultActive = (active: OkrKeyResult) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_ACTIVE),
    active,
})
export const setOkrKeyResultPopupMenuShow = (show: boolean) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_POPUP_MENU_SHOW),
    show,
})
export const setOkrKeyResultPopupMenuTarget = (target: HTMLElement) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_POPUP_MENU_TARGET),
    target,
})
export const setOkrKeyResultShowConfirmDelete = (show: boolean) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_SHOW_CONFIRM_DELETE),
    show,
})


export const setOkrKeyResultReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_RELOAD_EDIT),
    value,
})
